"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const User_1 = __importDefault(require("../models/User"));
class Account {
    constructor(options) {
        this.id = options.id;
        this.active_subscription = options.active_subscription;
        this.billing_email = options.billing_email;
        this.business_name = options.business_name;
        this.industry = options.industry;
        this.last_four_digits = options.last_four_digits;
        this.users = (Array.isArray(options.users) ? options.users : []).map(user => new User_1.default(user));
        this.forecasting_enabled = options.forecasting_enabled;
        this.onboarding_progress = options.onboarding_progress;
        this.masquerade = options.masquerade;
        this.group_code = options.group_code;
        this.parent_group_codes = options.parent_group_codes;
    }
    get Users() {
        return this.users.map(item => new User_1.default(item));
    }
    get ForecastingIsEnabled() {
        return this.forecasting_enabled === true;
    }
    get IsOnboarding() {
        return this.OnboardingProgress > -1;
    }
    get OnboardingProgress() {
        if (this.onboarding_progress === null) {
            return -1;
        }
        else {
            return parseInt(this.onboarding_progress);
        }
    }
    get isGroupAccount() {
        return this.group_code !== null;
    }
}
module.exports = Account;
